module.exports = __webpack_public_path__ + "media/images/emblems/Wikon_LU-4fb48c69187f571a0d42c47c3066b00c.png";